import { StrictMode } from "react";
import Lead360 from "./views/Lead360/index.jsx";
import "./index.css";
const Module = ({ name }) => {
  const defaultModule = Lead360;

  const moduleMapping = {
    lead360: Lead360,
  };

  const Module = moduleMapping[name] || defaultModule;

  return (
    <StrictMode>
      <div className={"moduleWrapper"}>
        <Module />
      </div>
    </StrictMode>
  );
};

export default Module;
